export default {
	es: {

		enlaces: {
			ofertas: '/ofertas',
			oferta: '/oferta',
			programaindependiente: '/programa-independiente',
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			espaciopersonal: '/espacio-personal',
			cv: '/mi-cv',
			miperfil: '/mi-perfil',
			informaciongeneral: '/informacion-general',
			datos_seguridad_social: '/datos-seguridad-social',
			politica_privacidad_seguridad_social: '/politica-privacidad-seguridad-social',
			eventos: '/eventos',
			evento: '/evento',
			login: '/login',
			candidaturas: '/candidaturas',
			practicasasignadas: '/practicas-asignadas',
			orientacionprofesional: '/orientacion-profesional',
			internacional: '/internacional',
			estudiaytrabaja: '/programa-estudia-y-trabaja',
			candidaturas: '/mis-candidaturas',
			testimonios: '/testimonios',
			misofertas : '/mis-ofertas',
			mioferta : "/mi-oferta",
			editaroferta : "/editar-oferta",
			nuevaoferta : "/nueva-oferta",
			nuevaempresa : '/nueva-empresa',
			practicasasignadas: '/practicas-asignadas',
			contacto: "/contacto",
			politica_privacidad: "/politica-de-privacidad",
			aviso_legal: "/aviso-legal",
			politica_cookies: "/politica-de-cookies",
			altaestudiantes : "/alta-estudiantes",
			candidatos : "/candidatos",
			empresas : "/empresas",
			busquedaCarta : "/busqueda-carta",
			nuevabusquedacarta : "/nueva-busqueda-carta",
			logout: '/logout',
			firmaredirect: '/firma',
			nuevocontacto: '/nuevo-contacto',
			establecerlogin : '/establecer-login',
			propuestapracticasempresa : '/propuesta-practicas/empresa',
			propuestapracticas : '/propuesta-practicas'
		},
		titles: {
			home : 'Portal Empleo UFV',
			ofertas: 'Ofertas',
			oferta: 'Oferta',
			encuestas: 'Encuestas',
			cv: 'Mi CV',
			informaciongeneral: 'Información general',
			datos_seguridad_social: 'Datos Seguridad Social',
			politica_privacidad_seguridad_social: 'Politica Privacidad Seguridad Social',
			eventos: 'Eventos',
			evento: 'Evento',
			login: 'Login',
			orientacionprofesional: 'Orientación profesional',
			testimonios: 'Testimonios',
			internacional: 'Internacional',
			candidaturas: 'Mis candidaturas',
			estudiaytrabaja: 'Programa estudia y trabaja',
			practicasasignadas: 'Prácticas asignadas',
			contacto: "Contacto",
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			logout: 'Cerrar sesión',
			misofertas : 'Mis ofertas',
			mioferta : 'Mi oferta',
			miperfil : 'Mi perfil',
			nuevaoferta : 'Nueva oferta',
			nuevaempresa : "Nueva empresa",
			altaestudiantes : "Alta estudiantes",
			busquedaCarta : "Búsqueda a la carta",
			candidatos : "Candidatos",
			firmaredirect : 'Cargando...',
			nuevocontacto : 'Nuevo contacto'
		},
		popupinfo: {
			url_portfolio: {
				titulo: 'URL del documento',
				texto: 'Si no puedes añadir tu documento porque supera 2Mb, añade aquí la url donde está alojado.'
			},
			limitaciones_fichero : {
				titulo : 'Ficheros permitidos',
				texto : '¡Atención! Los ficheros no pueden superar los 2Mb. Las extensiones permitidas son las siguientes: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff y tif.'
			},
			limitaciones_imagenes : {
				titulo : 'Imagenes permitidas',
				texto : '¡Atención! Las imagenes no pueden superar los 2Mb. Las extensiones permitidas son las siguientes: png, jpg, jpeg, bmp, gif, tiff y tif.'
			},
			info_cv : {
				titulo : "¡Atención!",
				texto : "Los documentos que añadas aquí podrán ser visibles para las empresas en cuyas ofertas seas candidato.<br>Te recomendamos que tengas siempre tu currículum lo más actualizado posible."
			},
			observaciones_ufv :{
				titulo : "Observaciones",
				texto : "Estas observaciones no serán visibles en la oferta. Son observaciones para los gestores de empleo de la UFV"
			},
			empresa_anonima :{
				titulo : "Quiero ocultar los datos de mi empresa para esta oferta",
				texto : "Por defecto, mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicar anónimamente, marca esta opción, no se mostrarán logo, nombre, contacto... de tu empresa."
			},
			consultora_ett :{
				titulo : "Consultora o ETT",
				texto : "Marque si publica esta oferta para un tercero"
			},
			uso_logo :{
				titulo : "Autorizo el uso de la imagen de la empresa",
				texto : "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en los portales de estudiantes y antiguos alumnos. Aunque autorices, cuando crees ofertas podrás configurar si quieres que se muestren los datos de tu empresa o no."
			},
			PrivadoEstudiante : {
				titulo : '',
				texto : 'Indica aquí tu NIF: si tienes DNI insértalo con letra, y sin espacios ni símbolos. Si tienes NIE o Pasaporte insértalo poniendo tanto las letras iniciales como las finales.'
			},
			PrivadoEmpresa : {
				titulo : '',
				texto : 'Indique aquí el usuario que registró cuando se dio de alta. En caso de duda puede utilizar la funcionalidad Recordar contraseña.'
			},
			PrivadoAlumnoEmpleo : {
				titulo : '',
				texto : 'Indica aquí tu NIF: si tienes DNI insértalo con letra, y sin espacios ni símbolos. Si tienes NIE o Pasaporte insértalo poniendo tanto las letras iniciales como las finales.'
			}
		}
	}
}






// WEBPACK FOOTER //
// ./src/translations/index.js